import { render, staticRenderFns } from "./ResourceCreate.vue?vue&type=template&id=a1bb2a5e"
import script from "./ResourceCreate.vue?vue&type=script&lang=js"
export * from "./ResourceCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports